import { useEffect, useState } from 'react';
import { IAgreementsData, IAgreementsUnsigned, IAgreementsUpdatePayload } from './common/agreementsReponse';
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { Grid, List, ListItem, ListItemIcon, ListItemText, TextField } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import { closelightbox } from "../../../util/Functions";


export type addFeatureInextProps = {
    changeAlert: any;
    onConfirm: (agreements:IAgreementsUpdatePayload[]) => void;
    onClose: () => void;
    changeLoader:(active:boolean)=>void;
    open: boolean;
    title: string;
    tab: string;
    roles: Array<object>;
    menu: Array<object>;
    categoryMenu: Array<object>;
    date:string;
    data?:IAgreementsData;
}


export const Agreements = ({ data, onClose, onConfirm, open, changeAlert, date, changeLoader}: addFeatureInextProps & DefaultComponentProps) => {
    const [unSigned,setUnsigned] = useState<IAgreementsUnsigned[]>([]);
    const [latitud,setLatitud] = useState<string>(localStorage.lat);
    const [longitud,setLongitud] = useState<string>(localStorage.lon);
    const [sending,setSending] = useState<boolean>(false);
    const [zPos, setZPos] = useState(0)

    const handleChange = (type:"longitud"|"latitud",value:string)=>{
        type === 'latitud' ? setLatitud(value) : setLongitud(value);
    }
    const handleUpdateValues = ()=>{
        setSending(true);
        if(longitud !== '' && latitud !== '' && unSigned.length > 0){
            let agreements: IAgreementsUpdatePayload[] = unSigned.map(e=>{
                const agreement:IAgreementsUpdatePayload = {
                    geoaddress:`[${latitud},${longitud}]`,
                    sign_date:date,
                    granted:true,
                    template:{
                        uuid:e.template.uuid,
                        version:e.template.version
                    }
                }
                return agreement
            });
            setZPos(45);
            closelightbox();
            onConfirm(agreements);
            changeLoader(true);
        }else{
            setZPos(0);
            setSending(false);
            console.error("Longitud y latidud no validos",{
                longitud,
                latitud,
                sending,
                unSigned:unSigned.length
            });
            changeAlert(true, "error", "No se puede enviar la solicitud");

        }
    }
    useEffect(()=>{
        if(data){
            setUnsigned(data.unsigned);
        }
        },[data])
    return (
        <Dialog onClose={onClose} open={open}  style={zPos !== 0 ? {zIndex:zPos} : {}} >
            <DialogTitle>
                <Typography variant="h1">Contratos pendientes</Typography>
            </DialogTitle>
            <DialogContent>
                <FlexGrid
                    fullHeight
                    fullWidth
                    direction="column"
                    justify='space-between'
                    alignItems='flex-start'
                    spacing={2}>
                        <Grid style={{
                            overflow:'auto',
                            height:unSigned.length === 0 ? '100px': '300px',
                        }}>
                            <List style={{
                               background:'whitesmoke'
                            }}>
                                {unSigned.length > 0 && unSigned.map((element,index)=>{
                                    return <ListItem key={index}>
                                        <ListItemIcon>
                                            <ArticleIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={element.template.title}
                                            secondary={<span>{element.template.uuid}</span>}
                                        />
                                    </ListItem>
                                })}
                                {unSigned.length === 0 && 
                                <p>
                                    <small>
                                        No se encontraron contratos pendientes por firmar
                                    </small>
                                </p>}
                            </List>
                        </Grid>
                        
                        <Typography variant='paragraph'>
                            Geolocalización:
                        </Typography>
                        <Grid style={{display:'flex',flexDirection:'row',marginTop:'12px'}}>
                            <TextField style={{padding:'5px'}} onChange={(e)=>{handleChange('latitud',e.target.value)}} label="Latitud"  size="small"  value={latitud}/>
                            <TextField style={{padding:'5px'}} onChange={(e)=>{handleChange('longitud',e.target.value)}} label="Longitud" size="small" value={longitud}/>
                        </Grid>
                        

                </FlexGrid>
            </DialogContent>
            <DialogActions>
                <FlexGrid
                    fullHeight
                    fullWidth
                    justify='space-between'
                    alignItems='flex-end'
                    style={{ marginTop: '20px', display: "flex" }}
                >
                    <FlexGrid item>
                        <Button onClick={closelightbox} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={handleUpdateValues} size='normal' disabled={longitud === '' && latitud === '' && unSigned.length === 0 && sending === false}>
                            Generar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}